// extracted by mini-css-extract-plugin
export default {"mainContainer":"Footer_mainContainer__3vuqZ","linkContainer":"Footer_linkContainer__zD2B6"};